// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"f20c290b","1731":"5f0adf25","4037":"5f0adf25","6966":"41dea777"}[chunkId] + ".chunk.css";
};